import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 175081 138350"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#fefefe;stroke-width:1940.2}.fil0{fill:#292525}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M10325 61570c0-18453 15012-33457 33459-33457 18450 0 33460 15004 33460 33457 0 18447-15010 33456-33460 33456-18447 0-33459-15009-33459-33456zm5548-56529c5984 0 10831 4846 10831 10835 0 5975-4847 10826-10831 10826S5041 21851 5041 15876c0-5989 4848-10835 10832-10835zm52864 3733c6065 0 11000 4932 11000 10997 0 6070-4935 11000-11000 11000s-10997-4930-10997-11000c0-6065 4935-10997 10997-10997zm-9380 92104h23504V8222c0-1551-1261-2806-2811-2806H26570C23855 2676 20095 970 15942 970 7687 970 970 7690 970 15942c0 3501 1253 6676 3275 9230v78509c0 1551 1257 2814 2808 2814h45124l7180-5617z"
        className="fill stroke1"
        style={{
          strokeWidth: 1940.2,
        }}
      />
      <path
        d="M44479 67767c-3562 0-6444-2880-6444-6439 0-3560 2882-6447 6444-6447 3560 0 6442 2890 6442 6447 0 3559-2882 6439-6442 6439zm-695-36851c-16901 0-30651 13747-30651 30654 0 16901 13750 30653 30651 30653 16902-2 30654-13752 30654-30653 0-16907-13752-30654-30654-30654zM68737 11583c4522 0 8191 3664 8191 8188 0 4527-3669 8194-8191 8194-4525 0-8191-3667-8191-8194 0-4524 3666-8188 8191-8188zM89786 135445c-4939 0-8944-4003-8944-8945 0-4940 4002-8947 8944-8947 2867 0 5396 1377 7030 3470l-2923 1036c-1461 522-2225 2127-1706 3583 408 1153 1493 1871 2643 1871 314 0 632-53 940-160l2943-1044c0 64 16 122 16 183 0 4948-4003 8953-8943 8953zm-29388-3682h-8425v-2814h8425v2814zm67385-16846H49167c-1548 0-2966 1245-3157 2788l-2109 16884c-193 1543 909 2791 2458 2791h84233c1548 0 2648-1248 2457-2788l-2108-16892c-191-1538-1610-2783-3158-2783zM131516 67767c-3557 0-6442-2880-6442-6439 0-3560 2885-6447 6442-6447 3560 0 6444 2890 6444 6447 0 3559-2884 6439-6444 6439zm-222-36851c-16904 0-30653 13747-30653 30654 0 16901 13749 30653 30653 30653 16900-2 30649-13752 30649-30653 0-16907-13749-30654-30649-30654zM106342 27965c4517 0 8191-3674 8191-8194 0-4514-3674-8188-8191-8188-4512 0-8189 3679-8189 8188 0 4520 3677 8194 8189 8194z"
        className="fill stroke1"
        style={{
          strokeWidth: 1940.2,
        }}
      />
      <path
        d="M159206 26702c-5984 0-10834-4851-10834-10826 0-5989 4850-10835 10834-10835 5978 0 10824 4846 10824 10835 7 5975-4838 10826-10824 10826zm-27912 68324c-18449 0-33459-15009-33459-33456 0-18453 15010-33457 33459-33457 18448 0 33457 15004 33457 33457 0 18447-15009 33456-33457 33456zM106342 8774c6065 0 10999 4932 10999 10997 0 6070-4934 11000-10999 11000-6063 0-10995-4930-10995-11000 0-6065 4932-10997 10995-10997zm52795-7804c-4155 0-7908 1706-10628 4446H94089c-1548 0-2805 1255-2805 2808v92654h26480l7183 5617h42147c1543 0 2806-1263 2806-2814V26312c2594-2696 4211-6345 4211-10370 0-8252-6717-14972-14974-14972z"
        className="fill stroke1"
        style={{
          strokeWidth: 1940.2,
        }}
      />
      <path
        d="M49554 112106h78015l-10770-8425H60324zM16397 10966c2755 0 4991 2233 4991 4991 0 2752-2236 4988-4991 4988-2754 0-4990-2236-4990-4988 0-2758 2236-4991 4990-4991zM159593 10966c2755 0 4988 2233 4988 4991 0 2752-2233 4988-4988 4988-2758 0-4991-2236-4991-4988 0-2758 2233-4991 4991-4991z"
        className="fill"
        style={{
          strokeWidth: 1940.2,
        }}
      />
    </g>
  </svg>
);
export default SvgComponent;
